import { __decorate } from "tslib";
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import lang from '@blade-sxp/portrait-management/lang/index';
import { getPortraitLibAll } from '@blade-sxp/portrait-management/api/porttaitLib';
import { DbSyncInfoRequestUserTypeEnum } from '@blade-sxp/device-management-pass/interfaces/dbSync';
import { dbsyncAdd } from '@blade-sxp/device-management-pass/api/dbSync';
import { LibStatusEnum } from '@blade-sxp/portrait-management/interfaces/common';
const Webapi = {
    getPortraitLibAll,
    dbsyncAdd,
};
let default_1 = class default_1 extends Vue {
    defaultProps = { multiple: true };
    visible;
    refresh;
    form = {
        libIds: [],
        userType: '',
    };
    loading = false;
    libList = [];
    filterUserType = [];
    get selfVisible() {
        if (this.visible) {
            this.form = {
                libIds: [],
                userType: '',
            };
        }
        return this.visible;
    }
    set selfVisible(val) {
        if (val && this.loading === false && this.libList.length === 0) {
            this.getPortraitLibAll();
        }
        this.$emit('update:visible', val);
    }
    get allowSubmit() {
        return this.form.libIds.length > 0 && this.libList.length > 0 && this.form.userType;
    }
    get libListOption() {
        if (!this.libList.map)
            return [];
        return this.libList
            .filter((lib) => lib.status === LibStatusEnum.ENABLE)
            .map((a) => {
            return {
                value: a.libId,
                label: a.libraryName,
            };
        });
    }
    initI18n() {
        this.filterUserType = [
            { text: String(this.$t('blacklist')), value: DbSyncInfoRequestUserTypeEnum.BLACKLIST },
            { text: String(this.$t('staff')), value: DbSyncInfoRequestUserTypeEnum.STAFF },
            { text: String(this.$t('guest')), value: DbSyncInfoRequestUserTypeEnum.GUEST },
        ];
    }
    created() {
        this.getPortraitLibAll();
    }
    mounted() {
        this.initI18n();
    }
    async getPortraitLibAll() {
        this.loading = true;
        try {
            this.libList = await Webapi.getPortraitLibAll();
        }
        catch (error) {
            console.log('getPortraitLibAll error', error);
        }
        this.loading = false;
    }
    cancelFunc() {
        this.selfVisible = false;
    }
    async submitFunc() {
        try {
            await Webapi.dbsyncAdd({
                lib_ids: this.form.libIds.map((a) => a[0]),
                user_type: this.form.userType,
                device_id: this.$route.query.deviceId.toString(),
            });
            this.$message({
                customClass: 'success-message',
                message: this.$t('distributedSuccessfully').toString(),
                type: 'success',
                showClose: true,
            });
            this.selfVisible = false;
            this.refresh();
        }
        catch (error) { }
    }
};
__decorate([
    Prop()
], default_1.prototype, "visible", void 0);
__decorate([
    Prop()
], default_1.prototype, "refresh", void 0);
__decorate([
    Watch('$i18n.locale')
], default_1.prototype, "initI18n", null);
default_1 = __decorate([
    Component({
        i18n: {
            messages: {
                en: {
                    ...lang.en,
                    add: 'Add',
                    distributedType: 'Distributed Type',
                    distributedTypeInputPlaceholder: 'Please select distributed type',
                    portraitLibInputPlaceholder: 'Please select portrait library',
                    blacklist: 'Black Library',
                    staff: 'Staff Library',
                    guest: 'Guest Library',
                    distributedSuccessfully: 'Distributed Successfully',
                },
                zh: {
                    ...lang.zh,
                    add: '添加',
                    distributedType: '下发类型',
                    distributedTypeInputPlaceholder: '请选择下发类型',
                    portraitLibInputPlaceholder: '请选择下发人像库',
                    blacklist: '黑名单库',
                    staff: '员工库',
                    guest: '访客库',
                    distributedSuccessfully: '下发成功',
                },
            },
        },
    })
], default_1);
export default default_1;
